// component imports
import { Component, AfterViewInit, Input } from '@angular/core';

// global properties
declare let jQuery: any;

@Component({
    selector: 'app-prompt',
    templateUrl: './prompt.component.html',
    standalone: false
})
export class PromptComponent implements AfterViewInit {
	// Inputs for the modal component
	@Input() public title: string;
	@Input() public identifier = 'olci-modal';
	@Input() public detectRouteChanges = 'true';

	public isClosed: boolean;

	protected el: any;

	ngAfterViewInit() {
		this.el = jQuery('#' + this.identifier);
		if (this.el !== null) {
			this.el.foundation();
		}
		jQuery('#timeoutExtendModal')
			.parent('.reveal-overlay')
			.css('z-index', 1050);
		jQuery('#timeoutEndedModal')
			.parent('.reveal-overlay')
			.css('z-index', 1060);
	}

	/**
	 * open a modal with the standard format
	 */
	open() {
		try {
			this.el.foundation('open');
			this.isClosed = false;
		} catch (e) {}
	}

	/**
	 * Close the modal
	 */
	close(keepElement?: boolean) {
		if (this.el !== null) {
			this.el.foundation('close');
			this.isClosed = true;
		}
	}
}
